import { render, staticRenderFns } from "./coopBatchPay.vue?vue&type=template&id=1b905cb8&scoped=true&"
import script from "./coopBatchPay.vue?vue&type=script&lang=js&"
export * from "./coopBatchPay.vue?vue&type=script&lang=js&"
import style0 from "./coopBatchPay.vue?vue&type=style&index=0&id=1b905cb8&prod&lang=scss&scoped=true&"
import style1 from "./coopBatchPay.vue?vue&type=style&index=1&id=1b905cb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b905cb8",
  null
  
)

export default component.exports